import type { SearchPerformancePagesSourceType } from '../api/searchPerformanceApi';
import type { SearchPerformancePagesLoadSourceType } from '../SearchPerformanceAnalyticsEvents';
import { requestDurationMs } from '../SearchPerformanceRequestLoad';
import useWidgetLoadTelemetry, {
  type LoadScopeValue,
  type WidgetLoadTelemetry,
  type WidgetReportingWindow,
} from '../useWidgetLoadTelemetry';
import type { PagesTabKey } from './PagesTabs';
import type { PagesLoadCycle } from './usePagesRows';

const PAGES_LOAD_SOURCE_TYPE: Record<SearchPerformancePagesSourceType, SearchPerformancePagesLoadSourceType> = {
  GSC: 'GSC',
  PRERENDER: 'PRERENDER',
};

type PagesLoad = {
  property: string | undefined;
  reportingWindow: WidgetReportingWindow;
  tab: PagesTabKey;
  interactionQueryArgs: readonly LoadScopeValue[];
  loadCycle: PagesLoadCycle;
};

export function usePagesLoadTelemetry({
  property,
  reportingWindow,
  tab,
  interactionQueryArgs,
  loadCycle,
}: PagesLoad): WidgetLoadTelemetry {
  const pagesLoadContext = {
    widget: 'pages',
    tab,
    source_type: PAGES_LOAD_SOURCE_TYPE[loadCycle.sourceType],
  } as const;
  return useWidgetLoadTelemetry({
    property,
    reportingWindow,
    tabKey: tab,
    interactionQueryArgs,
    load: loadCycle.load,
    loadedProperties: {
      ...pagesLoadContext,
      has_data: loadCycle.hasData,
      rows_visible_ms: requestDurationMs(loadCycle.load),
      partial: loadCycle.columns?.isError === true,
    },
    failedProperties: { ...pagesLoadContext, stage: 'rows' },
    companion: loadCycle.columns && {
      load: loadCycle.columns,
      failedProperties: { ...pagesLoadContext, stage: 'columns' },
    },
  });
}
